/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const UserThumbnailPut = {
  id: 'user.thumbnail.put',
  tag: 'User',
  summary: 'Update users thumbnail',
  description: 'Update users thumbnail',
  method: 'put',
  flags: { isAuthorized: true },
  route: () => `/user/thumbnail`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: ZodTypes.ThumbnailFormat,
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
